// Put all packages together.
// Used to generate umd/index.prod.js

import React from 'react';
import { createRoot } from 'react-dom/client';

import { IntlProvider } from 'react-intl';

import { initAdminParentAuth } from './lib/admin-parent-auth.js';
import { bootLog, initBootDiagnostics } from './lib/boot-diagnostics.js';
import { initChunkReloadHandler } from './lib/chunk-reload.js';
import { initNativeAuthBridge } from './lib/native-auth-bridge.js';
import { initWebVitals } from './lib/perf-metrics.js';
import TinodeWeb from './views/tinode-web.jsx';
import messages from './i18n.min/en.json';

// Blank-page diagnostics for the WebView embed (see boot-diagnostics.js).
// Installed before anything else so page lifecycle and global failures are
// captured for the whole bootstrap.
initBootDiagnostics();

// Recover from stale async-chunk references after a deploy (see chunk-reload.js).
// Installed first so it is listening before any lazy import() can fail.
initChunkReloadHandler();

// Start collecting Core Web Vitals as early as possible (see perf-metrics.js).
initWebVitals();

// Register admin-portal postMessage listener before bootstrap (see admin-parent-auth.js).
initAdminParentAuth();

// Expose AngkasAuth.login() for the Flutter WebView host (see native-auth-bridge.js).
// Must run before render so a token injected at document start is still readable.
initNativeAuthBridge();

document.getElementsByTagName('html')[0].setAttribute('lang', 'en');

const mountPoint = document.getElementById('mountPoint');
bootLog('react:render', {mountPointFound: !!mountPoint});

const root = createRoot(mountPoint);
root.render(
  <IntlProvider locale="en" messages={messages} textComponent={React.Fragment}>
    <TinodeWeb />
  </IntlProvider>
);
